import React, { useContext } from 'react';
import OIBForm from "./OibForm";
import { Card } from "../common/Card";
import { CookieConsent } from "./CookieConsent";
import { ZahtjevContext } from "../../common/context/ZahtjevProvider";
import { useTranslation } from "react-i18next";

const RegistrationPage = () => {
    const { isCookieConsentSet } = useContext(ZahtjevContext);
    const { t } = useTranslation();

    return (
      <>
          {!isCookieConsentSet() && <CookieConsent />}
          <Card title={t("registration-page.title")} className="mb-10 md:mb-12" bodyClassName="md:w-full">
              <div className="sr-only">{t("registration-page.description")}</div>

              <p className="mb-4 text-gray-600">
                  {t("registration-page.update-data-description.question")}
                  <br />
                  <br />
                  {t("registration-page.update-data-description.instructions.info")}
              </p>

              <ul className="list-none pl-0 space-y-2 mb-6 text-gray-700">
                  <li
                    className="relative pl-5 before:content-['•'] before:absolute before:left-0 before:top-[-2px] before:text-lg before:leading-snug before:text-[#52AE30] before:font-bold">
                      {t("registration-page.update-data-description.instructions.document-preparation")}
                  </li>
                  <li
                    className="relative pl-5 before:content-['•'] before:absolute before:left-0 before:top-[-2px] before:align-middle before:text-lg before:leading-snug before:text-[#52AE30] before:font-bold">
                      {t("registration-page.update-data-description.instructions.filling-form")}
                  </li>
              </ul>

              <section>
                  <OIBForm />
              </section>
          </Card>
      </>
    );
};

export default RegistrationPage;
